import Vue from 'vue'

export const ProfilePage = Vue.component('profile-page', require('./ProfilePage.vue'));
export const Profile = Vue.component('profile', require('./Profile.vue'));
export const AboutMe = Vue.component('about-me', require('./AboutMe.vue'));
export const ProfileBlocks = Vue.component('profile-blocks', require('./ProfileBlocks'));
export const ItemCard = Vue.component('item-card', require('./ItemCard'));



// WEBPACK FOOTER //
// ./resources/assets/js/views/my_profile/index.js